/* eslint-disable max-len */
import FlokiQuestion from 'images/coin-pages/questions/floki.svg'

import { commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const flokiPage: ICoinPageData = {
  title: 'coin_395',
  description: 'coin_396',
  // description:
  //   'Get a Floki loan. Receive up to 90% of your FLOKI loan collateral in cash or crypto and continue holding. Borrow bitcoin instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, locale, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Floki (FLOKI)' }) }} />
  ),
  questionsBlock: {
    image: FlokiQuestion,
    questions: [
      {
        title: 'coin_397',
        answer: 'coin_398',
      },
      {
        title: 'coin_399',
        answer: 'coin_400',
      },
      {
        title: 'coin_401',
        answer: 'coin_402',
      },
      {
        title: 'coin_403',
        answer: 'coin_404',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Floki (FLOKI)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_405',
        text: ['coin_407', 'coin_408'],
      },
      {
        title: 'coin_406',
        text: ['coin_409'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/floki-inu-loan/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/03/twitterCR_EARN1.png',
        imageAlt: 'What is FLOKI INU? And How to get a FLOKI Loan?',
      },
      {
        link: 'https://coinrabbit.io/blog/borrow-like-a-pro/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/06/Ltt.png',
        imageAlt: 'Crypto Loans: Tips and Tricks',
      },
      {
        link: 'https://coinrabbit.io/blog/cryptocrash/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/05/0.-Title.png',
        imageAlt: 'Surviving the Crypto Crash: How to take advantage of the crisis',
      },
    ],
  },
}
